export const GET_USER_ITEMS = 'GET_USER_ITEMS';
export const GET_USER_ITEMS_SUCCESS = 'GET_USER_ITEMS_SUCCESS';
export const GET_USER_ITEMS_FAILURE = 'GET_USER_ITEMS_FAILURE';

export const SELL_ITEM = 'SELL_ITEM';
export const SELL_ITEM_SUCCESS = 'SELL_ITEM_SUCCESS';
export const SELL_ITEM_FAILURE = 'SELL_ITEM_FAILURE';
export const RESET_SELL_ITEM = 'RESET_SELL_ITEM';
